module.exports = __webpack_public_path__ + "img/select-border.14838882.png";